import { useState, useRef, useEffect, Fragment } from "react"

const STATUS_STYLES = {
  running: { bg:"#dcfce7", color:"#16a34a", label:"Đang chạy" },
  stopped: { bg:"#fee2e2", color:"#dc2626", label:"Dừng"      },
  open:    { bg:"#dbeafe", color:"#2563eb", label:"Mở"        },
  ok:      { bg:"#f1f5f9", color:"#64748b", label:"OK"        },
}

const SILOS = [
  { id:"SL-01", name:"Silo Biomass A", type:"Biomass",   fill:78, cap:200, unit:"t",  temp:22.4, humid:14.2, flow:+8.5, status:"running", alarm:false, color:"#22c55e" },
  { id:"SL-02", name:"Silo Biomass B", type:"Biomass",   fill:43, cap:200, unit:"t",  temp:21.8, humid:15.1, flow:-3.2, status:"running", alarm:false, color:"#22c55e" },
  { id:"SL-03", name:"Silo Pellets C",  type:"Pellets",    fill:91, cap:150, unit:"t",  temp:20.1, humid:10.8, flow: 0,   status:"ok",      alarm:true,  color:"#f59e0b" },
  { id:"SL-04", name:"Silo Pellets D",  type:"Pellets",    fill:12, cap:150, unit:"t",  temp:23.6, humid:18.4, flow:-5.0, status:"stopped", alarm:true,  color:"#ef4444" },
  { id:"SL-05", name:"Silo Viên nén E", type:"Viên nén",   fill:55, cap:100, unit:"t",  temp:19.7, humid:12.0, flow:+2.1, status:"running", alarm:false, color:"#22c55e" },
  { id:"SL-06", name:"Bể Nước F", type:"Eau",        fill:68, cap:500, unit:"m³", temp:18.0, humid:null, flow:+12.0,status:"running", alarm:false, color:"#2563eb" },
]

const TRANSFERS = [
  { from:"SL-01", to:"SL-03", flow:8.5,  color:"#22c55e", active:true },
  { from:"SL-02", to:"SL-04", flow:3.2,  color:"#f59e0b", active:false },
  { from:"SL-05", to:"SL-03", flow:2.1,  color:"#22c55e", active:true },
]

function SiloGauge({ fill=50, color="#22c55e", width=52, height=90, alarm=false }) {
  const pct = Math.min(fill/100, 1)
  const fillH = pct * (height - 20)
  const alarmPct = 0.9
  return (
    <svg viewBox={`0 0 ${width} ${height+10}`} style={{width, height:height+10, display:"block"}}>
      {/* Body */}
      <rect x={6} y={4} width={width-12} height={height} rx={4} fill="white" stroke="#e2e8f0" strokeWidth={1.5}/>
      {/* Fill */}
      <clipPath id={`clip-${fill}-${color}`}>
        <rect x={7} y={4} width={width-14} height={height}/>
      </clipPath>
      <rect
        x={7} y={4+(height-fillH)} width={width-14} height={fillH}
        rx={2} fill={alarm && fill>88 ? "#ef4444" : color} opacity={0.75}
        clipPath={`url(#clip-${fill}-${color})`}
      />
      {/* Alarm threshold line */}
      <line x1={6} y1={4+(height*0.1)} x2={width-6} y2={4+(height*0.1)}
        stroke="#ef4444" strokeWidth={1} strokeDasharray="3 2" opacity={0.5}/>
      {/* % text */}
      <text x={width/2} y={4+height/2+5} textAnchor="middle"
        fontSize={13} fontWeight="800" fill={fill>88&&alarm?"#ef4444":"#0f172a"}>{fill}%</text>
      {/* Bottom outlet nub */}
      <rect x={width/2-4} y={height+3} width={8} height={8} rx={2} fill="#94a3b8"/>
    </svg>
  )
}

function FlowArrow({ direction="right", color="#22c55e", active=true, flow=0 }) {
  return (
    <div style={{display:"flex",flexDirection:"column",alignItems:"center",gap:2}}>
      <div style={{
        display:"flex",alignItems:"center",gap:0,opacity:active?1:0.3
      }}>
        {[0,1,2].map(i=>(
          <div key={i} style={{
            width:14, height:4,
            background:`linear-gradient(${direction==="right"?"90deg":"270deg"}, ${color}ee, ${color}44)`,
            borderRadius:2, marginRight:2,
            animation: active ? `none` : undefined
          }}/>
        ))}
        <span style={{fontSize:14, color, lineHeight:1}}>{direction==="right"?"▶":"◀"}</span>
      </div>
      <span style={{fontSize:8,color:"#94a3b8",whiteSpace:"nowrap"}}>{active?`${flow} t/h`:"arrêté"}</span>
    </div>
  )
}

function SiloDetailPanel({ silo, onClose }) {
  const pct = silo.fill
  const trendData = Array.from({length:24},(_,i)=>{
    const base = silo.fill + (Math.random()-0.5)*8
    return Math.max(5, Math.min(99, base + Math.sin(i/3)*6))
  })
  const barMax = Math.max(...trendData)

  return (
    <div>
      {/* Header */}
      <div style={{
        padding:"10px 14px", background:"#f8fafc", borderBottom:"1px solid #e2e8f0",
        display:"flex", alignItems:"center", justifyContent:"space-between"
      }}>
        <div>
          <span style={{fontSize:9,color:"#94a3b8",fontFamily:"monospace"}}>{silo.id} · </span>
          <span style={{fontSize:12,fontWeight:700,color:"#0f172a"}}>{silo.name}</span>
        </div>
        <div style={{display:"flex",gap:6,alignItems:"center"}}>
          {silo.alarm && <span style={{
            width:18,height:18,borderRadius:"50%",background:"#ef4444",
            display:"inline-flex",alignItems:"center",justifyContent:"center",fontSize:9,color:"white",fontWeight:900
          }}>!</span>}
          <button style={{background:"none",border:"none",cursor:"pointer",color:"#94a3b8",fontSize:16}}>⋯</button>
        </div>
      </div>

      {/* Gauge + live value */}
      <div style={{
        padding:"14px", display:"flex", gap:14, alignItems:"center",
        background:"white", borderBottom:"1px solid #f1f5f9"
      }}>
        <SiloGauge fill={silo.fill} color={silo.color} alarm={silo.alarm} width={44} height={80}/>
        <div style={{flex:1}}>
          <div style={{fontSize:22,fontWeight:800,color:silo.alarm&&silo.fill>88?"#ef4444":"#0f172a",lineHeight:1}}>
            {(silo.fill/100*silo.cap).toFixed(1)}
            <span style={{fontSize:12,fontWeight:400,color:"#94a3b8",marginLeft:4}}>{silo.unit}</span>
          </div>
          <div style={{fontSize:10,color:"#64748b",marginTop:3}}>
            Capacité : {silo.cap} {silo.unit}
          </div>
          <div style={{
            marginTop:6,display:"inline-flex",alignItems:"center",gap:4,
            background:STATUS_STYLES[silo.status]?.bg,color:STATUS_STYLES[silo.status]?.color,
            padding:"2px 8px",borderRadius:10,fontSize:10,fontWeight:600
          }}>{STATUS_STYLES[silo.status]?.label}</div>
        </div>
      </div>

      {/* Fields */}
      {[
        ["Mức điền",  `${silo.fill}%`],
        ["Type",         silo.type],
        ["Lưu lượng hiện tại",  silo.flow>0?`+${silo.flow} t/h`:silo.flow<0?`${silo.flow} t/h`:"Dừng"],
        ["Nhiệt độ",  `${silo.temp} °C`],
        ...(silo.humid!=null ? [["Độ ẩm", `${silo.humid} %`]] : []),
        ["Cảnh báo",       silo.alarm ? "⚠ Active" : "Không có"],
      ].map(([k,v])=>(
        <div key={k} style={{
          display:"flex",justifyContent:"space-between",alignItems:"center",
          padding:"6px 14px",borderBottom:"1px solid #f8fafc"
        }}>
          <span style={{fontSize:11,color:"#94a3b8"}}>{k}</span>
          <span style={{
            fontSize:11,fontWeight:600,
            color:k==="Cảnh báo"&&silo.alarm?"#ef4444":k==="Lưu lượng hiện tại"?silo.flow>0?"#22c55e":silo.flow<0?"#f59e0b":"#94a3b8":"#0f172a"
          }}>{v}</span>
        </div>
      ))}

      {/* 24h trend */}
      <div style={{padding:"8px 14px 2px",fontSize:9,fontWeight:700,color:"#94a3b8",letterSpacing:1,background:"#f8fafc",marginTop:6}}>
        DERNIÈRES 24H
      </div>
      <div style={{padding:"6px 14px 14px",background:"#f8fafc"}}>
        <div style={{display:"flex",alignItems:"flex-end",gap:1,height:52}}>
          {trendData.map((v,i)=>{
            const h = (v/barMax)*100
            const c = v>88&&silo.alarm?"#ef4444":v<20?"#f59e0b":silo.color
            return <div key={i} style={{flex:1,height:`${h}%`,background:c,borderRadius:"1px 1px 0 0",opacity:0.85}}/>
          })}
        </div>
        <div style={{display:"flex",justifyContent:"space-between",marginTop:3}}>
          <span style={{fontSize:7,color:"#94a3b8"}}>-24h</span>
          <span style={{fontSize:7,color:"#94a3b8"}}>hiện tại</span>
        </div>
      </div>
    </div>
  )
}

// ── Silo balance data ──────────────────────────────────────
const ENTREES = [
  { id:"EN-01", label:"Xe tải Biomass",   icon:"🚛", flow:+8.5, unit:"t/h", color:"#22c55e", active:true,  silos:["SL-01","SL-02"] },
  { id:"EN-02", label:"Băng tải Pellets", icon:"⚙",  flow:+5.0, unit:"t/h", color:"#f59e0b", active:false, silos:["SL-03","SL-04"] },
  { id:"EN-03", label:"Giao hàng Viên nén",icon:"📦", flow:+2.1, unit:"t/h", color:"#22c55e", active:true,  silos:["SL-05"] },
]
const SORTIES = [
  { id:"SO-01", label:"Nồi hơi CH1",     icon:"🔥", flow:-6.0, unit:"t/h", color:"#ef4444", active:true,  silos:["SL-01","SL-03"] },
  { id:"SO-02", label:"Nồi hơi CH2",     icon:"🔥", flow:-3.5, unit:"t/h", color:"#f97316", active:true,  silos:["SL-02","SL-04"] },
  { id:"SO-03", label:"Phân phối ECS",  icon:"💧", flow:-2.8, unit:"t/h", color:"#2563eb", active:true,  silos:["SL-06"] },
  { id:"SO-04", label:"Xuất mạng lưới",     icon:"↗",  flow: 0,   unit:"t/h", color:"#94a3b8", active:false, silos:[] },
]

function SiloBalanceView() {
  const [selectedItem, setSelectedItem] = useState(null)  // {type:"silo"|"entree"|"sortie", data}
  const [hoveredId,    setHoveredId]    = useState(null)

  const totalMass = SILOS.reduce((s,sl)=>s+(sl.fill/100*sl.cap),0).toFixed(1)
  const totalCap  = SILOS.reduce((s,sl)=>s+sl.cap,0)
  const avgFill   = (SILOS.reduce((s,sl)=>s+sl.fill,0)/SILOS.length).toFixed(0)
  const alarmsN   = SILOS.filter(s=>s.alarm).length

  // ── Synoptic-style pipe connector ──
  const HPipe = ({color="#22c55e", active=true, flow=0, width=28}) => (
    <div style={{display:"flex",flexDirection:"column",alignItems:"center",gap:1,flexShrink:0}}>
      <div style={{
        width, height:3,
        background: active ? color : "#e2e8f0",
        borderRadius:2, opacity: active ? 1 : 0.5,
        boxShadow: active ? `0 0 4px ${color}66` : "none",
        transition:"all .2s"
      }}/>
      {flow!==0 && <span style={{fontSize:7,color:active?color:"#94a3b8",fontWeight:600,whiteSpace:"nowrap"}}>
        {flow>0?`+${flow}`:flow} t/h
      </span>}
    </div>
  )

  // ── Arrow tip ──
  const Arrow = ({color="#22c55e", active=true, dir="right"}) => (
    <span style={{
      fontSize:10, color: active ? color : "#e2e8f0",
      flexShrink:0, lineHeight:1,
      filter: active ? `drop-shadow(0 0 2px ${color}88)` : "none"
    }}>{dir==="right"?"▶":"◀"}</span>
  )

  // ── Section column header ──
  const ColHeader = ({title, count, onAdd}) => (
    <div style={{
      display:"flex",alignItems:"center",justifyContent:"space-between",
      marginBottom:12
    }}>
      <span style={{fontSize:11,fontWeight:700,color:"#64748b",letterSpacing:1,textTransform:"uppercase"}}>
        {title} <span style={{fontWeight:400,fontSize:10,color:"#94a3b8"}}>({count})</span>
      </span>
      <button onClick={onAdd} style={{
        width:22,height:22,borderRadius:"50%",background:"#22c55e",border:"none",
        cursor:"pointer",fontSize:14,color:"white",
        display:"flex",alignItems:"center",justifyContent:"center",
        boxShadow:"0 1px 4px rgba(34,197,94,.4)",flexShrink:0
      }}>+</button>
    </div>
  )

  // ── Flow card (Entrées / Sorties) ──
  const FlowCard = ({item, type}) => {
    const isSel   = selectedItem?.data?.id===item.id
    const isHov   = hoveredId===item.id
    return (
      <div
        onClick={()=>setSelectedItem(isSel?null:{type,data:item})}
        onMouseEnter={()=>setHoveredId(item.id)}
        onMouseLeave={()=>setHoveredId(null)}
        style={{
          background:"white",border:`2px solid ${isSel?"#2563eb":item.active?"#e2e8f0":"#f1f5f9"}`,
          borderRadius:8,padding:"10px 12px",cursor:"pointer",marginBottom:8,
          boxShadow:isSel?"0 0 0 3px rgba(37,99,235,.15)":isHov?"0 2px 8px rgba(0,0,0,0.08)":"none",
          transition:"all .15s", opacity: item.active ? 1 : 0.6
        }}
      >
        <div style={{display:"flex",alignItems:"center",gap:6,marginBottom:6}}>
          <span style={{fontSize:16}}>{item.icon}</span>
          <div style={{flex:1}}>
            <div style={{fontSize:11,fontWeight:700,color:"#374151"}}>{item.label}</div>
            <div style={{fontSize:9,fontFamily:"monospace",color:"#94a3b8"}}>{item.id}</div>
          </div>
          {!item.active && <span style={{
            fontSize:9,background:"#fee2e2",color:"#dc2626",
            padding:"1px 6px",borderRadius:8,fontWeight:600
          }}>Dừng</span>}
        </div>
        {/* Flow row */}
        <div style={{display:"flex",alignItems:"center",gap:4}}>
          <div style={{width:14,height:3,background:item.active?item.color:"#e2e8f0",borderRadius:2}}/>
          {/* Mini flow node (synoptic style) */}
          <svg viewBox="0 0 28 18" style={{width:28,height:18,flexShrink:0}}>
            <rect x={1} y={2} width={12} height={14} rx={2} fill="white" stroke={item.active?item.color:"#e2e8f0"} strokeWidth={1.5}/>
            <circle cx={7} cy={9} r={3} fill={item.active?item.color:"#e2e8f0"} opacity={0.3}/>
            <circle cx={7} cy={9} r={1.5} fill={item.active?item.color:"#e2e8f0"}/>
            <line x1={13} y1={9} x2={18} y2={9} stroke={item.active?item.color:"#e2e8f0"} strokeWidth={1.5}/>
            <rect x={18} y={2} width={9} height={14} rx={2} fill="white" stroke={item.active?item.color:"#e2e8f0"} strokeWidth={1.5}/>
          </svg>
          <div style={{width:6,height:3,background:item.active?item.color:"#e2e8f0",borderRadius:2}}/>
          <Arrow color={item.color} active={item.active} dir={type==="entree"?"right":"left"}/>
          <div style={{flex:1,textAlign:"right"}}>
            <span style={{fontSize:13,fontWeight:800,color:item.active?item.color:"#94a3b8"}}>
              {Math.abs(item.flow)}
            </span>
            <span style={{fontSize:9,color:"#94a3b8",marginLeft:2}}>{item.unit}</span>
          </div>
        </div>
        {/* Linked silos chips */}
        {item.silos.length>0 && (
          <div style={{display:"flex",gap:3,marginTop:6,flexWrap:"wrap"}}>
            {item.silos.map(sid=>(
              <span key={sid} style={{
                fontSize:8,fontFamily:"monospace",background:"#f1f5f9",
                color:"#64748b",padding:"1px 5px",borderRadius:4
              }}>{sid}</span>
            ))}
          </div>
        )}
      </div>
    )
  }

  // ── Detail panel (right side) ──
  const DetailPanel = () => {
    if (!selectedItem) return (
      <div style={{
        height:"100%",display:"flex",flexDirection:"column",
        alignItems:"center",justifyContent:"center",
        color:"#94a3b8",fontSize:12,padding:20,textAlign:"center",gap:8
      }}>
        <span style={{fontSize:32}}>🗄</span>
        <span style={{fontWeight:600,color:"#64748b"}}>Chọn một phần tử</span>
        <span style={{fontSize:11,color:"#cbd5e1",lineHeight:1.5}}>
          Cliquer sur un silo, une entrée ou une sortie pour afficher ses informations
        </span>
      </div>
    )
    if (selectedItem.type==="silo") return <SiloDetailPanel silo={selectedItem.data} onClose={()=>setSelectedItem(null)}/>

    const item = selectedItem.data
    const linkedSilos = SILOS.filter(s=>item.silos.includes(s.id))
    const trendH = Array.from({length:18},(_,i)=>0.4+Math.abs(Math.sin(i/2.5))*0.5)
    return (
      <div>
        <div style={{padding:"10px 14px",background:"#f8fafc",borderBottom:"1px solid #e2e8f0",display:"flex",alignItems:"center",justifyContent:"space-between"}}>
          <div>
            <span style={{fontSize:9,color:"#94a3b8",fontFamily:"monospace"}}>{item.id} · </span>
            <span style={{fontSize:12,fontWeight:700,color:"#0f172a"}}>{item.label}</span>
          </div>
          <button style={{background:"none",border:"none",cursor:"pointer",color:"#94a3b8",fontSize:16}}>⋯</button>
        </div>
        <div style={{display:"flex",borderBottom:"1px solid #f1f5f9"}}>
          {["Thông tin","Cảnh báo"].map((t,i)=>(
            <button key={t} style={{padding:"8px 12px",border:"none",cursor:"pointer",fontSize:11,
              fontWeight:i===0?700:400,color:i===0?"#2563eb":"#94a3b8",
              borderBottom:i===0?"2px solid #2563eb":"2px solid transparent",background:"none"}}>{t}</button>
          ))}
        </div>
        {[
          ["Type",          selectedItem.type==="entree"?"Cung cấp":"Distribution"],
          ["Débit actuel",  `${Math.abs(item.flow)} ${item.unit}`],
          ["Direction",     selectedItem.type==="entree"?"Vào ▶":"◀ Ra"],
          ["Trạng thái",        item.active?"Đang chạy":"Dừng"],
          ["Silo liên kết",    item.silos.join(", ")||"—"],
        ].map(([k,v])=>(
          <div key={k} style={{display:"flex",justifyContent:"space-between",padding:"7px 14px",borderBottom:"1px solid #f8fafc"}}>
            <span style={{fontSize:11,color:"#94a3b8"}}>{k}</span>
            <span style={{fontSize:11,fontWeight:600,color:k==="Trạng thái"?(item.active?"#16a34a":"#dc2626"):"#0f172a"}}>{v}</span>
          </div>
        ))}
        {/* Linked silos mini summary */}
        {linkedSilos.length>0 && (
          <div style={{padding:"10px 14px",background:"#f8fafc",marginTop:6}}>
            <div style={{fontSize:9,fontWeight:700,color:"#94a3b8",letterSpacing:1,marginBottom:8}}>SILO LIÊN KẾT</div>
            {linkedSilos.map(s=>(
              <div key={s.id} onClick={()=>setSelectedItem({type:"silo",data:s})} style={{
                display:"flex",alignItems:"center",gap:8,padding:"6px 0",
                borderBottom:"1px solid #f1f5f9",cursor:"pointer"
              }}>
                <SiloGauge fill={s.fill} color={s.color} alarm={s.alarm} width={20} height={36}/>
                <div style={{flex:1}}>
                  <div style={{fontSize:10,fontWeight:600,color:"#0f172a"}}>{s.name}</div>
                  <div style={{fontSize:9,color:s.color,fontWeight:600}}>{s.fill}% · {(s.fill/100*s.cap).toFixed(0)} {s.unit}</div>
                </div>
                {s.alarm && <span style={{width:14,height:14,borderRadius:"50%",background:"#ef4444",display:"inline-flex",alignItems:"center",justifyContent:"center",fontSize:7,color:"white",fontWeight:900}}>!</span>}
              </div>
            ))}
          </div>
        )}
        {/* Mini trend */}
        <div style={{padding:"8px 14px 2px",fontSize:9,fontWeight:700,color:"#94a3b8",letterSpacing:1,background:"#f8fafc",marginTop:4}}>6H QUA</div>
        <div style={{padding:"6px 14px 14px",background:"#f8fafc"}}>
          <div style={{display:"flex",alignItems:"flex-end",gap:1,height:44}}>
            {trendH.map((h,i)=>(
              <div key={i} style={{flex:1,height:`${h*100}%`,background:item.active?item.color:"#e2e8f0",borderRadius:"1px 1px 0 0",opacity:0.8}}/>
            ))}
          </div>
        </div>
      </div>
    )
  }

  // ─────────────────────────────────────────────────────────

  return (
    <div style={{flex:1,display:"flex",overflow:"hidden"}}>

      {/* ── Main 3-column canvas ── */}
      <div style={{flex:1,overflow:"auto",padding:"14px 16px"}}>

        {/* KPI strip */}
        <div style={{display:"flex",gap:8,marginBottom:14,flexWrap:"wrap"}}>
          {[
            {label:"Khối lượng tổng",     value:`${totalMass} t`,  icon:"⚖",  color:"#2563eb"},
            {label:"Tổng dung tích",  value:`${totalCap} t`,   icon:"🗄",  color:"#64748b"},
            {label:"Mức điền TB", value:`${avgFill}%`,      icon:"📊", color:"#22c55e"},
            {label:"Cảnh báo hoạt động",  value:`${alarmsN}`,       icon:"⚠",  color:alarmsN>0?"#ef4444":"#22c55e"},
          ].map(k=>(
            <div key={k.label} style={{
              background:"white",border:"1px solid #e2e8f0",borderRadius:8,
              padding:"8px 12px",display:"flex",alignItems:"center",gap:8,flex:1,minWidth:110,
              boxShadow:"0 1px 3px rgba(0,0,0,0.04)"
            }}>
              <span style={{fontSize:18}}>{k.icon}</span>
              <div>
                <div style={{fontSize:15,fontWeight:800,color:k.color,lineHeight:1}}>{k.value}</div>
                <div style={{fontSize:9,color:"#94a3b8",marginTop:1}}>{k.label}</div>
              </div>
            </div>
          ))}
        </div>

        {/* 3-column synoptic flow */}
        <div style={{display:"flex",gap:0,minWidth:700}}>

          {/* ── ENTRÉES ── */}
          <div style={{flex:1,borderRight:"1px solid #e2e8f0",paddingRight:12}}>
            <ColHeader title="Đầu vào" count={ENTREES.length} onAdd={()=>{}}/>
            {ENTREES.map(item=><FlowCard key={item.id} item={item} type="entree"/>)}
          </div>

          {/* ── STOCKAGE (silos) ── */}
          <div style={{flex:1.6,borderRight:"1px solid #e2e8f0",padding:"0 12px"}}>
            <ColHeader title="Lưu trữ" count={SILOS.length} onAdd={()=>{}}/>
            {/* Silos grid 2 × N */}
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8}}>
              {SILOS.map(silo=>{
                const isSel = selectedItem?.data?.id===silo.id
                const isHov = hoveredId===silo.id
                const inFlow  = ENTREES.filter(e=>e.silos.includes(silo.id)&&e.active)
                const outFlow = SORTIES.filter(s=>s.silos.includes(silo.id)&&s.active)
                return (
                  <div key={silo.id}
                    onClick={()=>setSelectedItem(isSel?null:{type:"silo",data:silo})}
                    onMouseEnter={()=>setHoveredId(silo.id)}
                    onMouseLeave={()=>setHoveredId(null)}
                    style={{
                      background:"white",border:`2px solid ${isSel?"#2563eb":silo.alarm?"#fca5a5":"#e2e8f0"}`,
                      borderRadius:8,padding:"10px",cursor:"pointer",
                      boxShadow:isSel?"0 0 0 3px rgba(37,99,235,.15)":isHov?"0 2px 8px rgba(0,0,0,0.08)":"0 1px 3px rgba(0,0,0,0.04)",
                      transition:"all .15s",position:"relative"
                    }}
                  >
                    {/* Alarm badge */}
                    {silo.alarm && (
                      <div style={{
                        position:"absolute",top:-7,right:-7,
                        width:18,height:18,borderRadius:"50%",background:"#ef4444",
                        display:"flex",alignItems:"center",justifyContent:"center",
                        boxShadow:"0 2px 6px rgba(239,68,68,.45)",zIndex:2
                      }}>
                        <span style={{fontSize:8,color:"white",fontWeight:900}}>!</span>
                      </div>
                    )}

                    {/* Flow in/out pipes */}
                    <div style={{display:"flex",alignItems:"center",gap:4,marginBottom:8}}>
                      {/* Inputs (green arrows in) */}
                      {inFlow.map(e=>(
                        <div key={e.id} style={{display:"flex",alignItems:"center",gap:2}}>
                          <div style={{width:10,height:3,background:e.color,borderRadius:2,boxShadow:`0 0 3px ${e.color}88`}}/>
                          <span style={{fontSize:8,color:e.color}}>▶</span>
                        </div>
                      ))}
                      <div style={{flex:1}}/>
                      {/* Outputs (red arrows out) */}
                      {outFlow.map(s=>(
                        <div key={s.id} style={{display:"flex",alignItems:"center",gap:2}}>
                          <span style={{fontSize:8,color:s.color}}>▶</span>
                          <div style={{width:10,height:3,background:s.color,borderRadius:2,boxShadow:`0 0 3px ${s.color}88`}}/>
                        </div>
                      ))}
                    </div>

                    {/* Gauge + info */}
                    <div style={{display:"flex",gap:8,alignItems:"center"}}>
                      <SiloGauge fill={silo.fill} color={silo.color} alarm={silo.alarm} width={44} height={72}/>
                      <div style={{flex:1,minWidth:0}}>
                        <div style={{fontSize:10,fontWeight:700,color:"#374151",lineHeight:1.2,marginBottom:3}}>
                          {silo.name.replace("Silo ","").replace("Réservoir ","")}
                        </div>
                        <div style={{fontSize:8,fontFamily:"monospace",color:"#94a3b8",marginBottom:5}}>{silo.id}</div>
                        <div style={{fontSize:14,fontWeight:800,color:silo.alarm&&silo.fill>88?"#ef4444":"#0f172a",lineHeight:1}}>
                          {(silo.fill/100*silo.cap).toFixed(0)}
                          <span style={{fontSize:9,fontWeight:400,color:"#94a3b8",marginLeft:2}}>{silo.unit}</span>
                        </div>
                        <div style={{fontSize:8,color:"#94a3b8",marginTop:1}}>/ {silo.cap} {silo.unit}</div>
                        {/* Flux badge */}
                        <div style={{
                          marginTop:5,display:"inline-flex",fontSize:8,fontWeight:600,
                          padding:"1px 6px",borderRadius:8,
                          background:silo.flow>0?"#dcfce7":silo.flow<0?"#fef3c7":"#f1f5f9",
                          color:silo.flow>0?"#16a34a":silo.flow<0?"#92400e":"#64748b"
                        }}>
                          {silo.flow>0?`▲ +${silo.flow}`:silo.flow<0?`▼ ${silo.flow}`:"—"} t/h
                        </div>
                        {/* Status chip */}
                        <div style={{
                          marginTop:4,display:"inline-flex",alignItems:"center",gap:3,
                          background:STATUS_STYLES[silo.status]?.bg,color:STATUS_STYLES[silo.status]?.color,
                          padding:"1px 7px",borderRadius:8,fontSize:8,fontWeight:600
                        }}>
                          <div style={{width:5,height:5,borderRadius:"50%",background:STATUS_STYLES[silo.status]?.color}}/>
                          {STATUS_STYLES[silo.status]?.label}
                        </div>
                      </div>
                    </div>
                  </div>
                )
              })}
            </div>

            {/* Transfer table */}
            <div style={{marginTop:12,background:"white",border:"1px solid #e2e8f0",borderRadius:8,overflow:"hidden"}}>
              <div style={{padding:"8px 12px",background:"#f8fafc",borderBottom:"1px solid #f1f5f9",fontSize:10,fontWeight:700,color:"#64748b",letterSpacing:0.8,textTransform:"uppercase"}}>
                Transferts inter-silos
              </div>
              <table style={{width:"100%",borderCollapse:"collapse",fontSize:11}}>
                <tbody>
                  {TRANSFERS.map((t,i)=>{
                    const src = SILOS.find(s=>s.id===t.from)
                    const dst = SILOS.find(s=>s.id===t.to)
                    return (
                      <tr key={i} style={{borderBottom:"1px solid #f8fafc"}}>
                        <td style={{padding:"6px 12px",fontWeight:600,color:"#374151"}}>{src?.name.replace("Silo ","")}</td>
                        <td style={{padding:"6px 4px",textAlign:"center"}}>
                          <div style={{display:"flex",alignItems:"center",gap:2,justifyContent:"center"}}>
                            <div style={{width:12,height:2,background:t.color,opacity:t.active?1:0.3}}/>
                            <span style={{fontSize:10,color:t.active?t.color:"#e2e8f0"}}>▶</span>
                            <div style={{width:12,height:2,background:t.color,opacity:t.active?1:0.3}}/>
                          </div>
                        </td>
                        <td style={{padding:"6px 4px",fontWeight:600,color:"#374151"}}>{dst?.name.replace("Silo ","")}</td>
                        <td style={{padding:"6px 8px",fontWeight:700,color:t.color,whiteSpace:"nowrap"}}>{t.flow} t/h</td>
                        <td style={{padding:"6px 12px"}}>
                          <span style={{
                            fontSize:9,fontWeight:600,padding:"1px 7px",borderRadius:8,
                            background:t.active?"#dcfce7":"#fee2e2",color:t.active?"#16a34a":"#dc2626"
                          }}>{t.active?"Hoạt động":"Dừng"}</span>
                        </td>
                      </tr>
                    )
                  })}
                </tbody>
              </table>
            </div>
          </div>

          {/* ── SORTIES ── */}
          <div style={{flex:1,paddingLeft:12}}>
            <ColHeader title="Đầu ra" count={SORTIES.length} onAdd={()=>{}}/>
            {SORTIES.map(item=><FlowCard key={item.id} item={item} type="sortie"/>)}
          </div>

        </div>
      </div>

      {/* ── Right detail panel ── */}
      <div style={{
        width:268,background:"white",borderLeft:"1px solid #e2e8f0",
        flexShrink:0,overflowY:"auto"
      }}>
        <DetailPanel/>
      </div>
    </div>
  )
}

// ─── Sintering Line (Công nghệ Thiêu Kết) ───────────────

const SINTER_ZONES = [
  { id:"Z1", pos:-4.3, temp:249.0, alarm:false, color:"#22c55e" },
  { id:"Z2", pos:-5.8, temp:141.6, alarm:true,  color:"#ef4444" },
  { id:"Z3", pos:-5.2, temp:null,  alarm:true,  color:"#f59e0b" },
  { id:"Z4", pos:-5.1, temp:327.5, alarm:false, color:"#22c55e" },
  { id:"Z5", pos: 0.0, temp:327.6, alarm:false, color:"#22c55e" },
  { id:"Z6", pos: 7.8, temp:120.0, alarm:false, color:"#22c55e" },
  { id:"Z7", pos:-6.5, temp:177.8, alarm:false, color:"#22c55e" },
  { id:"Z8", pos:-5.2, temp:210.0, alarm:false, color:"#22c55e" },
]

const SINTER_INPUTS = [
  { id:"AL-01", label:"Máy Rải Liệu",    icon:"🏗", speed:8.6,  setpoint:8.0,  unit:"m/min", color:"#22c55e", active:true  },
  { id:"AL-02", label:"Phối Liệu",       icon:"📦", speed:null, setpoint:null, unit:"t/h",   color:"#2563eb", active:true  },
]
const SINTER_MACHINE = { id:"MK-01", label:"Máy Thiêu Kết", icon:"⚙", speed:61.1, setpoint:60.0, unit:"m/min", color:"#f59e0b", active:true }
const TE1206 = { value:1040.1, unit:"°C", alarm:true }
const SINTER_OUTPUTS = [
  { id:"GS-01", label:"Khí Than Nóng",   icon:"🔥", flow:6638,  unit:"Nm³/h", press:-526.8, color:"#ef4444", active:true  },
  { id:"GS-02", label:"Khống Khí Nóng",  icon:"💨", flow:3391,  unit:"Nm³/h", press:-624.3, color:"#2563eb", active:true  },
  { id:"GS-03", label:"Khí Gas Wheel",   icon:"🌀", flow:2.30,  unit:"m³/s",  press:null,   color:"#f59e0b", active:true  },
  { id:"GS-04", label:"Khí Thoát Wheel", icon:"↗",  flow:7.18,  unit:"m³/s",  press:null,   color:"#22c55e", active:true  },
]

// ── Zone fill gauge (same style as SiloGauge) ──
function ZoneGauge({ pct=50, color="#22c55e", alarm=false, width=52, height=90 }) {
  const fillH = Math.min(pct/100,1)*(height-12)
  return (
    <svg viewBox={`0 0 ${width} ${height+8}`} style={{width,height:height+8,display:"block",flexShrink:0}}>
      <rect x={4} y={3} width={width-8} height={height} rx={3}
        fill="white" stroke={alarm?"#fca5a5":"#e2e8f0"} strokeWidth={1.5}/>
      <rect x={5} y={3+(height-fillH)} width={width-10} height={fillH}
        rx={2} fill={alarm?"#ef4444":color} opacity={0.75}/>
      <line x1={4} y1={3+height*0.15} x2={width-4} y2={3+height*0.15}
        stroke="#ef4444" strokeWidth={1} strokeDasharray="3 2" opacity={0.35}/>
      <text x={width/2} y={3+height/2+5} textAnchor="middle"
        fontSize={Math.max(9,width/5.5)} fontWeight="800"
        fill={alarm?"#ef4444":"#0f172a"}>{Math.round(pct)}%</text>
      <rect x={width/2-3} y={height+2} width={6} height={6} rx={1} fill="#94a3b8"/>
    </svg>
  )
}

// ── Belt visual (white card, no SCADA colors) ──
function SinterBelt({ zones, selectedZone, onZoneClick }) {
  return (
    <div style={{
      background:"white",border:"1px solid #e2e8f0",borderRadius:8,
      padding:"12px 14px",marginBottom:14,
      boxShadow:"0 1px 4px rgba(0,0,0,0.05)"
    }}>
      <div style={{
        fontSize:11,fontWeight:700,color:"#64748b",
        letterSpacing:1,textTransform:"uppercase",marginBottom:10
      }}>Băng Tải Thiêu Kết</div>
      {/* Belt body */}
      <div style={{
        height:28,borderRadius:4,position:"relative",overflow:"hidden",
        background:"linear-gradient(180deg,#e2e8f0 0%,#cbd5e1 50%,#94a3b8 100%)",
        marginBottom:8,boxShadow:"inset 0 2px 3px rgba(0,0,0,0.1)"
      }}>
        {Array.from({length:36},(_,i)=>(
          <div key={i} style={{
            position:"absolute",left:`${(i/36)*100}%`,top:0,bottom:0,
            width:"2.4%",background:"rgba(0,0,0,0.06)",
            borderRight:"1px solid rgba(255,255,255,0.15)"
          }}/>
        ))}
        {zones.map((z,idx)=>{
          const x=`${(idx/(zones.length-1))*88+6}%`
          const isSel=selectedZone?.id===z.id
          return (
            <div key={z.id} onClick={()=>onZoneClick(z)} style={{
              position:"absolute",left:x,top:"50%",
              transform:"translate(-50%,-50%)",cursor:"pointer",zIndex:2
            }}>
              <div style={{
                width:18,height:18,borderRadius:"50%",
                background:z.alarm?"#ef4444":isSel?"#2563eb":z.color,
                border:isSel?"2px solid #1d4ed8":"2px solid white",
                boxShadow:`0 1px 4px ${z.alarm?"rgba(239,68,68,.5)":isSel?"rgba(37,99,235,.4)":"rgba(0,0,0,.15)"}`,
                display:"flex",alignItems:"center",justifyContent:"center",
                transition:"all .15s"
              }}>
                {z.alarm&&<span style={{fontSize:7,color:"white",fontWeight:900}}>!</span>}
              </div>
            </div>
          )
        })}
      </div>
      {/* Zone labels row */}
      <div style={{display:"flex"}}>
        {zones.map(z=>{
          const isSel=selectedZone?.id===z.id
          return (
            <div key={z.id} onClick={()=>onZoneClick(z)} style={{
              flex:1,display:"flex",flexDirection:"column",alignItems:"center",
              cursor:"pointer",padding:"3px 1px",
              background:isSel?"#eff6ff":"transparent",
              borderRadius:4,transition:"background .1s"
            }}>
              <span style={{
                fontSize:8,fontWeight:700,
                color:isSel?"#2563eb":z.alarm?"#ef4444":"#374151"
              }}>{z.id}</span>
              <span style={{
                fontSize:8,fontFamily:"monospace",fontWeight:600,
                color:z.alarm?"#ef4444":z.color
              }}>{z.pos>0?`+${z.pos}`:z.pos}</span>
              {z.temp!=null&&<span style={{fontSize:7,color:"#94a3b8"}}>{z.temp}°</span>}
            </div>
          )
        })}
      </div>
    </div>
  )
}

function SinteringLineView() {
  const [selectedItem, setSelectedItem] = useState(null)
  const [selectedZone, setSelectedZone] = useState(null)
  const [hoveredId,    setHoveredId]    = useState(null)
  const [machineOn,    setMachineOn]    = useState(true)

  const alarmsN = SINTER_ZONES.filter(z=>z.alarm).length + (TE1206.alarm?1:0)
  const avgTemp = (SINTER_ZONES.filter(z=>z.temp).reduce((s,z)=>s+z.temp,0)/
    SINTER_ZONES.filter(z=>z.temp).length).toFixed(0)

  // ── same HPipe as SiloBalanceView ──
  const HPipe = ({color="#22c55e",active=true,flow=null,width=28,unit=""}) => (
    <div style={{display:"flex",flexDirection:"column",alignItems:"center",gap:1,flexShrink:0}}>
      <div style={{
        width,height:3,
        background:active?color:"#e2e8f0",
        borderRadius:2,opacity:active?1:0.5,
        boxShadow:active?`0 0 4px ${color}66`:"none",
        transition:"all .2s"
      }}/>
      {flow!=null&&<span style={{fontSize:7,color:active?color:"#94a3b8",fontWeight:600,whiteSpace:"nowrap"}}>
        {flow>0?`+${flow}`:flow} {unit}
      </span>}
    </div>
  )

  // ── same Arrow as SiloBalanceView ──
  const Arrow = ({color="#22c55e",active=true,dir="right"}) => (
    <span style={{
      fontSize:10,color:active?color:"#e2e8f0",
      flexShrink:0,lineHeight:1,
      filter:active?`drop-shadow(0 0 2px ${color}88)`:"none"
    }}>{dir==="right"?"▶":"◀"}</span>
  )

  // ── same ColHeader as SiloBalanceView ──
  const ColHeader = ({title,count,extra=null}) => (
    <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:12}}>
      <span style={{fontSize:11,fontWeight:700,color:"#64748b",letterSpacing:1,textTransform:"uppercase"}}>
        {title} <span style={{fontWeight:400,fontSize:10,color:"#94a3b8"}}>({count})</span>
      </span>
      {extra||<button style={{
        width:22,height:22,borderRadius:"50%",background:"#22c55e",border:"none",
        cursor:"pointer",fontSize:14,color:"white",
        display:"flex",alignItems:"center",justifyContent:"center",
        boxShadow:"0 1px 4px rgba(34,197,94,.4)",flexShrink:0
      }}>+</button>}
    </div>
  )

  // ── Input card (Alimentation) — same style as FlowCard ──
  const InputCard = ({item}) => {
    const isSel = selectedItem?.data?.id===item.id
    const isHov = hoveredId===item.id
    return (
      <div
        onClick={()=>setSelectedItem(isSel?null:{type:"input",data:item})}
        onMouseEnter={()=>setHoveredId(item.id)}
        onMouseLeave={()=>setHoveredId(null)}
        style={{
          background:"white",border:`2px solid ${isSel?"#2563eb":item.active?"#e2e8f0":"#f1f5f9"}`,
          borderRadius:8,padding:"10px 12px",cursor:"pointer",marginBottom:8,
          boxShadow:isSel?"0 0 0 3px rgba(37,99,235,.15)":isHov?"0 2px 8px rgba(0,0,0,0.08)":"none",
          transition:"all .15s",opacity:item.active?1:0.6
        }}>
        <div style={{display:"flex",alignItems:"center",gap:6,marginBottom:6}}>
          <span style={{fontSize:16}}>{item.icon}</span>
          <div style={{flex:1}}>
            <div style={{fontSize:11,fontWeight:700,color:"#374151"}}>{item.label}</div>
            <div style={{fontSize:9,fontFamily:"monospace",color:"#94a3b8"}}>{item.id}</div>
          </div>
          <span style={{
            fontSize:9,background:item.active?"#dcfce7":"#fee2e2",
            color:item.active?"#16a34a":"#dc2626",
            padding:"1px 6px",borderRadius:8,fontWeight:600
          }}>{item.active?"Đang chạy":"Dừng"}</span>
        </div>
        <div style={{display:"flex",alignItems:"center",gap:4}}>
          <div style={{width:14,height:3,background:item.active?item.color:"#e2e8f0",borderRadius:2}}/>
          <svg viewBox="0 0 28 18" style={{width:28,height:18,flexShrink:0}}>
            <rect x={1} y={2} width={12} height={14} rx={2} fill="white" stroke={item.active?item.color:"#e2e8f0"} strokeWidth={1.5}/>
            <circle cx={7} cy={9} r={3} fill={item.active?item.color:"#e2e8f0"} opacity={0.3}/>
            <circle cx={7} cy={9} r={1.5} fill={item.active?item.color:"#e2e8f0"}/>
            <line x1={13} y1={9} x2={18} y2={9} stroke={item.active?item.color:"#e2e8f0"} strokeWidth={1.5}/>
            <rect x={18} y={2} width={9} height={14} rx={2} fill="white" stroke={item.active?item.color:"#e2e8f0"} strokeWidth={1.5}/>
          </svg>
          <div style={{width:6,height:3,background:item.active?item.color:"#e2e8f0",borderRadius:2}}/>
          <Arrow color={item.color} active={item.active} dir="right"/>
          <div style={{flex:1,textAlign:"right"}}>
            {item.speed!=null&&<>
              <span style={{fontSize:13,fontWeight:800,color:item.active?item.color:"#94a3b8"}}>{item.speed}</span>
              <span style={{fontSize:9,color:"#94a3b8",marginLeft:2}}>{item.unit}</span>
            </>}
          </div>
        </div>
        {item.setpoint!=null&&(
          <div style={{marginTop:4,fontSize:9,color:"#64748b"}}>
            Cài đặt : <span style={{fontWeight:600,fontFamily:"monospace",color:"#374151"}}>{item.setpoint} {item.unit}</span>
          </div>
        )}
      </div>
    )
  }

  // ── Center machine card ──
  const MachineCard = ({item,running,te}) => {
    const isSel = selectedItem?.data?.id===item.id
    const isHov = hoveredId===item.id
    const pct   = (item.speed/item.setpoint)*100
    return (
      <div
        onClick={()=>setSelectedItem(isSel?null:{type:"machine",data:item})}
        onMouseEnter={()=>setHoveredId(item.id)}
        onMouseLeave={()=>setHoveredId(null)}
        style={{
          background:"white",border:`2px solid ${isSel?"#2563eb":running?"#e2e8f0":"#fca5a5"}`,
          borderRadius:8,padding:"12px",cursor:"pointer",marginBottom:8,
          boxShadow:isSel?"0 0 0 3px rgba(37,99,235,.15)":isHov?"0 2px 8px rgba(0,0,0,0.08)":"none",
          transition:"all .15s"
        }}>
        <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:10}}>
          <div style={{
            width:34,height:34,borderRadius:6,background:"#1e293b",
            display:"flex",alignItems:"center",justifyContent:"center",
            fontSize:18,flexShrink:0
          }}>🔥</div>
          <div style={{flex:1}}>
            <div style={{fontSize:11,fontWeight:700,color:"#374151"}}>{item.label}</div>
            <div style={{fontSize:9,fontFamily:"monospace",color:"#94a3b8"}}>{item.id}</div>
          </div>
          <span style={{
            fontSize:9,background:running?"#dcfce7":"#fee2e2",
            color:running?"#16a34a":"#dc2626",
            padding:"1px 6px",borderRadius:8,fontWeight:600
          }}>{running?"Đang chạy":"Dừng"}</span>
        </div>
        {/* Speed row */}
        <div style={{display:"flex",gap:10,marginBottom:8}}>
          <div style={{flex:1}}>
            <div style={{fontSize:9,color:"#94a3b8",marginBottom:1}}>Tốc Độ</div>
            <div style={{fontSize:20,fontWeight:900,color:"#0f172a",lineHeight:1}}>
              {item.speed}<span style={{fontSize:10,fontWeight:400,color:"#94a3b8",marginLeft:2}}>{item.unit}</span>
            </div>
          </div>
          <div style={{flex:1}}>
            <div style={{fontSize:9,color:"#94a3b8",marginBottom:1}}>Cài Đặt</div>
            <div style={{fontSize:14,fontWeight:700,color:"#64748b",lineHeight:1}}>
              {item.setpoint}<span style={{fontSize:9,fontWeight:400,color:"#94a3b8",marginLeft:2}}>{item.unit}</span>
            </div>
            <div style={{fontSize:8,color:Math.abs(item.speed-item.setpoint)<1?"#22c55e":"#f59e0b",marginTop:1}}>
              Δ {Math.abs(item.speed-item.setpoint).toFixed(1)} {item.unit}
            </div>
          </div>
        </div>
        {/* Progress bar */}
        <div style={{height:5,background:"#f1f5f9",borderRadius:3,overflow:"hidden",marginBottom:8}}>
          <div style={{
            height:"100%",borderRadius:3,transition:"width .3s",
            width:`${Math.min(pct,100)}%`,
            background:pct>98?"#ef4444":pct>90?"#f59e0b":"#22c55e"
          }}/>
        </div>
        {/* TE1206 */}
        {te&&(
          <div style={{
            padding:"6px 8px",borderRadius:6,
            background:te.alarm?"#fef2f2":"#f8fafc",
            border:`1px solid ${te.alarm?"#fca5a5":"#e2e8f0"}`
          }}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"baseline"}}>
              <span style={{fontSize:9,color:"#94a3b8"}}>TE1206</span>
              {te.alarm&&<span style={{fontSize:8,color:"#ef4444",fontWeight:600}}>⚠ Vượt ngưỡng</span>}
            </div>
            <div style={{fontSize:18,fontWeight:900,
              color:te.alarm?"#ef4444":"#0f172a",fontFamily:"monospace",lineHeight:1.2}}>
              {te.value} <span style={{fontSize:10,fontWeight:400,color:"#94a3b8"}}>{te.unit}</span>
            </div>
          </div>
        )}
      </div>
    )
  }

  // ── Output card (Flux gaz) — same style as FlowCard ──
  const OutputCard = ({item}) => {
    const isSel = selectedItem?.data?.id===item.id
    const isHov = hoveredId===item.id
    return (
      <div
        onClick={()=>setSelectedItem(isSel?null:{type:"output",data:item})}
        onMouseEnter={()=>setHoveredId(item.id)}
        onMouseLeave={()=>setHoveredId(null)}
        style={{
          background:"white",border:`2px solid ${isSel?"#2563eb":item.active?"#e2e8f0":"#f1f5f9"}`,
          borderRadius:8,padding:"10px 12px",cursor:"pointer",marginBottom:8,
          boxShadow:isSel?"0 0 0 3px rgba(37,99,235,.15)":isHov?"0 2px 8px rgba(0,0,0,0.08)":"none",
          transition:"all .15s",opacity:item.active?1:0.6
        }}>
        <div style={{display:"flex",alignItems:"center",gap:6,marginBottom:6}}>
          <span style={{fontSize:16}}>{item.icon}</span>
          <div style={{flex:1}}>
            <div style={{fontSize:11,fontWeight:700,color:"#374151"}}>{item.label}</div>
            <div style={{fontSize:9,fontFamily:"monospace",color:"#94a3b8"}}>{item.id}</div>
          </div>
          {!item.active&&<span style={{
            fontSize:9,background:"#fee2e2",color:"#dc2626",
            padding:"1px 6px",borderRadius:8,fontWeight:600
          }}>Dừng</span>}
        </div>
        <div style={{display:"flex",alignItems:"center",gap:4}}>
          <Arrow color={item.color} active={item.active} dir="left"/>
          <div style={{width:6,height:3,background:item.active?item.color:"#e2e8f0",borderRadius:2}}/>
          <svg viewBox="0 0 28 18" style={{width:28,height:18,flexShrink:0}}>
            <rect x={1} y={2} width={12} height={14} rx={2} fill="white" stroke={item.active?item.color:"#e2e8f0"} strokeWidth={1.5}/>
            <circle cx={7} cy={9} r={3} fill={item.active?item.color:"#e2e8f0"} opacity={0.3}/>
            <circle cx={7} cy={9} r={1.5} fill={item.active?item.color:"#e2e8f0"}/>
            <line x1={13} y1={9} x2={18} y2={9} stroke={item.active?item.color:"#e2e8f0"} strokeWidth={1.5}/>
            <rect x={18} y={2} width={9} height={14} rx={2} fill="white" stroke={item.active?item.color:"#e2e8f0"} strokeWidth={1.5}/>
          </svg>
          <div style={{width:8,height:3,background:item.active?item.color:"#e2e8f0",borderRadius:2}}/>
          <div style={{flex:1,textAlign:"right"}}>
            <span style={{fontSize:13,fontWeight:800,color:item.active?item.color:"#94a3b8"}}>{item.flow}</span>
            <span style={{fontSize:9,color:"#94a3b8",marginLeft:2}}>{item.unit}</span>
          </div>
        </div>
        {item.press!=null&&(
          <div style={{marginTop:4,fontSize:9,color:"#64748b"}}>
            Pression : <span style={{fontWeight:600,fontFamily:"monospace",
              color:item.press<-500?"#f59e0b":"#374151"}}>{item.press} Pa</span>
          </div>
        )}
      </div>
    )
  }

  // ── Right detail panel — same structure as SiloBalanceView ──
  const DetailPanel = () => {
    if (!selectedItem&&!selectedZone) return (
      <div style={{
        height:"100%",display:"flex",flexDirection:"column",
        alignItems:"center",justifyContent:"center",
        color:"#94a3b8",fontSize:12,padding:20,textAlign:"center",gap:8
      }}>
        <span style={{fontSize:32}}>⚙</span>
        <span style={{fontWeight:600,color:"#64748b"}}>Chọn một phần tử</span>
        <span style={{fontSize:11,color:"#cbd5e1",lineHeight:1.5}}>
          Nhấp vào zone, thiết bị hoặc lưu lượng khí để xem thông tin
        </span>
      </div>
    )

    // Zone detail
    if (selectedZone&&(!selectedItem||selectedItem?.type==="zone")) {
      const z = selectedZone
      const pct = z.temp?Math.min(z.temp/400*100,100):0
      const trend = Array.from({length:18},(_,i)=>
        Math.max(5,Math.min(95,pct+Math.sin(i/2)*14+(Math.random()-.5)*8))
      )
      return (
        <div>
          <div style={{padding:"10px 14px",background:"#f8fafc",borderBottom:"1px solid #e2e8f0",
            display:"flex",alignItems:"center",justifyContent:"space-between"}}>
            <div>
              <span style={{fontSize:9,color:"#94a3b8",fontFamily:"monospace"}}>{z.id} · </span>
              <span style={{fontSize:12,fontWeight:700,color:"#0f172a"}}>Zone {z.id.slice(1)}</span>
            </div>
            {z.alarm&&<span style={{width:18,height:18,borderRadius:"50%",background:"#ef4444",
              display:"inline-flex",alignItems:"center",justifyContent:"center",
              fontSize:9,color:"white",fontWeight:900}}>!</span>}
          </div>
          <div style={{display:"flex",borderBottom:"1px solid #f1f5f9"}}>
            {["Thông tin","Cảnh báo"].map((t,i)=>(
              <button key={t} style={{padding:"8px 12px",border:"none",cursor:"pointer",fontSize:11,
                fontWeight:i===0?700:400,color:i===0?"#2563eb":"#94a3b8",
                borderBottom:i===0?"2px solid #2563eb":"2px solid transparent",background:"none"}}>{t}</button>
            ))}
          </div>
          <div style={{padding:"10px 14px",display:"flex",gap:10,alignItems:"center",
            background:"white",borderBottom:"1px solid #f1f5f9"}}>
            <ZoneGauge pct={pct} color={z.color} alarm={z.alarm} width={44} height={72}/>
            <div>
              <div style={{fontSize:18,fontWeight:900,
                color:z.alarm?"#ef4444":"#0f172a",lineHeight:1}}>
                {z.temp!=null?z.temp:"—"}
                <span style={{fontSize:10,fontWeight:400,color:"#94a3b8",marginLeft:3}}>°C</span>
              </div>
              <div style={{fontSize:9,color:"#64748b",marginTop:3}}>Max : 400 °C</div>
              <div style={{marginTop:6,display:"inline-flex",alignItems:"center",gap:4,
                background:z.alarm?"#fee2e2":"#dcfce7",
                color:z.alarm?"#dc2626":"#16a34a",
                padding:"2px 8px",borderRadius:10,fontSize:9,fontWeight:600}}>
                {z.alarm?"⚠ Cảnh báo":"✓ Bình thường"}
              </div>
            </div>
          </div>
          {[["Vị trí",`${z.pos>0?"+"+z.pos:z.pos} kPa`],
            ["Nhiệt độ",z.temp?`${z.temp} °C`:"—"],
            ["Trạng thái",z.alarm?"⚠ Cảnh báo":"Bình thường"],
          ].map(([k,v])=>(
            <div key={k} style={{display:"flex",justifyContent:"space-between",
              padding:"7px 14px",borderBottom:"1px solid #f8fafc"}}>
              <span style={{fontSize:11,color:"#94a3b8"}}>{k}</span>
              <span style={{fontSize:11,fontWeight:600,
                color:k==="Trạng thái"&&z.alarm?"#ef4444":"#0f172a"}}>{v}</span>
            </div>
          ))}
          <div style={{padding:"8px 14px 2px",fontSize:9,fontWeight:700,
            color:"#94a3b8",letterSpacing:1,background:"#f8fafc",marginTop:4}}>24H QUA</div>
          <div style={{padding:"6px 14px 14px",background:"#f8fafc"}}>
            <div style={{display:"flex",alignItems:"flex-end",gap:1,height:44}}>
              {trend.map((v,i)=>(
                <div key={i} style={{flex:1,height:`${v}%`,
                  background:z.alarm&&v>85?"#ef4444":z.color,
                  borderRadius:"1px 1px 0 0",opacity:0.8}}/>
              ))}
            </div>
            <div style={{display:"flex",justifyContent:"space-between",marginTop:2}}>
              <span style={{fontSize:7,color:"#94a3b8"}}>-24h</span>
              <span style={{fontSize:7,color:"#94a3b8"}}>hiện tại</span>
            </div>
          </div>
        </div>
      )
    }

    // Machine / flow detail
    const item = selectedItem.data
    const isAlarm = item.alarm||(item.active===false)||(selectedItem.type==="machine"&&!machineOn)
    const trend = Array.from({length:18},(_,i)=>
      30+Math.abs(Math.sin(i/3))*50+(Math.random()-.5)*8
    )
    const fields = selectedItem.type==="machine" ? [
      ["Tốc Độ",   `${item.speed} ${item.unit}`],
      ["Cài Đặt",  `${item.setpoint} ${item.unit}`],
      ["Sai lệch", `Δ ${Math.abs(item.speed-item.setpoint).toFixed(1)} ${item.unit}`],
      ["Trạng thái", machineOn?"Đang chạy":"Dừng"],
    ] : selectedItem.type==="input" ? [
      ["Tốc Độ",   item.speed!=null?`${item.speed} ${item.unit}`:"—"],
      ["Cài Đặt",  item.setpoint!=null?`${item.setpoint} ${item.unit}`:"—"],
      ["Trạng thái", item.active?"Đang chạy":"Dừng"],
    ] : [
      ["Lưu lượng", `${item.flow} ${item.unit}`],
      ["Áp suất",   item.press!=null?`${item.press} Pa`:"—"],
      ["Trạng thái", item.active?"Hoạt động":"Dừng"],
    ]
    return (
      <div>
        <div style={{padding:"10px 14px",background:"#f8fafc",borderBottom:"1px solid #e2e8f0",
          display:"flex",alignItems:"center",justifyContent:"space-between"}}>
          <div>
            <span style={{fontSize:9,color:"#94a3b8",fontFamily:"monospace"}}>{item.id} · </span>
            <span style={{fontSize:12,fontWeight:700,color:"#0f172a"}}>{item.label}</span>
          </div>
          <button style={{background:"none",border:"none",cursor:"pointer",color:"#94a3b8",fontSize:16}}>⋯</button>
        </div>
        <div style={{display:"flex",borderBottom:"1px solid #f1f5f9"}}>
          {["Thông tin","Lịch sử"].map((t,i)=>(
            <button key={t} style={{padding:"8px 12px",border:"none",cursor:"pointer",fontSize:11,
              fontWeight:i===0?700:400,color:i===0?"#2563eb":"#94a3b8",
              borderBottom:i===0?"2px solid #2563eb":"2px solid transparent",background:"none"}}>{t}</button>
          ))}
        </div>
        {fields.map(([k,v])=>(
          <div key={k} style={{display:"flex",justifyContent:"space-between",
            padding:"7px 14px",borderBottom:"1px solid #f8fafc"}}>
            <span style={{fontSize:11,color:"#94a3b8"}}>{k}</span>
            <span style={{fontSize:11,fontWeight:600,
              color:k==="Trạng thái"?isAlarm?"#dc2626":"#16a34a":"#0f172a"}}>{v}</span>
          </div>
        ))}
        <div style={{padding:"8px 14px 2px",fontSize:9,fontWeight:700,
          color:"#94a3b8",letterSpacing:1,background:"#f8fafc",marginTop:4}}>GIỜ VỪA QUA</div>
        <div style={{padding:"6px 14px 14px",background:"#f8fafc"}}>
          <div style={{display:"flex",alignItems:"flex-end",gap:1,height:44}}>
            {trend.map((v,i)=>(
              <div key={i} style={{flex:1,height:`${v}%`,
                background:item.color||"#22c55e",
                borderRadius:"1px 1px 0 0",opacity:0.8}}/>
            ))}
          </div>
          <div style={{display:"flex",justifyContent:"space-between",marginTop:2}}>
            <span style={{fontSize:7,color:"#94a3b8"}}>-1h</span>
            <span style={{fontSize:7,color:"#94a3b8"}}>hiện tại</span>
          </div>
        </div>
      </div>
    )
  }

  // ── Zone grid (center column) ──
  const ZoneGrid = () => (
    <div style={{
      background:"white",border:"1px solid #e2e8f0",borderRadius:8,
      padding:"12px",boxShadow:"0 1px 4px rgba(0,0,0,0.05)",marginTop:8
    }}>
      <div style={{fontSize:11,fontWeight:700,color:"#64748b",
        letterSpacing:1,textTransform:"uppercase",marginBottom:10}}>
        Zones de dépression
      </div>
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr 1fr",gap:5}}>
        {SINTER_ZONES.map(z=>{
          const isSel = selectedZone?.id===z.id
          const pct = z.temp?Math.min(z.temp/400*100,100):0
          return (
            <div key={z.id} onClick={()=>{
              setSelectedZone(prev=>prev?.id===z.id?null:z)
              setSelectedItem(prev=>prev?.data?.id===z.id?null:{type:"zone",data:z})
            }} style={{
              background:isSel?"#eff6ff":"#f8fafc",
              border:`1px solid ${isSel?"#2563eb":z.alarm?"#fca5a5":"#e2e8f0"}`,
              borderRadius:6,padding:"6px 4px",cursor:"pointer",
              textAlign:"center",transition:"all .15s",position:"relative"
            }}>
              {z.alarm&&<div style={{
                position:"absolute",top:-5,right:-5,
                width:14,height:14,borderRadius:"50%",background:"#ef4444",
                display:"flex",alignItems:"center",justifyContent:"center"
              }}><span style={{fontSize:7,color:"white",fontWeight:900}}>!</span></div>}
              <ZoneGauge pct={pct} color={z.color} alarm={z.alarm} width={32} height={44}/>
              <div style={{fontSize:8,fontWeight:700,
                color:isSel?"#2563eb":z.alarm?"#ef4444":"#374151"}}>{z.id}</div>
              <div style={{fontSize:7,fontFamily:"monospace",
                color:z.alarm?"#ef4444":z.color,fontWeight:600}}>
                {z.pos>0?`+${z.pos}`:z.pos}
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )

  return (
    <div style={{flex:1,display:"flex",overflow:"hidden"}}>

      {/* ── Main 3-column canvas ── */}
      <div style={{flex:1,overflow:"auto",padding:"14px 16px"}}>

        {/* KPI strip — identical to SiloBalanceView */}
        <div style={{display:"flex",gap:8,marginBottom:14,flexWrap:"wrap"}}>
          {[
            {label:"Temp. TE1206",       value:`${TE1206.value} °C`, icon:"🔥", color:"#ef4444"},
            {label:"Tốc độ thiêu kết",   value:`${SINTER_MACHINE.speed} m/min`, icon:"⚙",  color:"#2563eb"},
            {label:"Temp. moy. zones",   value:`${avgTemp} °C`,      icon:"🌡", color:"#f59e0b"},
            {label:"Cảnh báo hoạt động", value:`${alarmsN}`,         icon:"⚠",  color:alarmsN>0?"#ef4444":"#22c55e"},
          ].map(k=>(
            <div key={k.label} style={{
              background:"white",border:"1px solid #e2e8f0",borderRadius:8,
              padding:"8px 12px",display:"flex",alignItems:"center",gap:8,
              flex:1,minWidth:110,boxShadow:"0 1px 3px rgba(0,0,0,0.04)"
            }}>
              <span style={{fontSize:18}}>{k.icon}</span>
              <div>
                <div style={{fontSize:15,fontWeight:800,color:k.color,lineHeight:1}}>{k.value}</div>
                <div style={{fontSize:9,color:"#94a3b8",marginTop:1}}>{k.label}</div>
              </div>
            </div>
          ))}
        </div>

        {/* Belt */}
        <SinterBelt
          zones={SINTER_ZONES}
          selectedZone={selectedZone}
          onZoneClick={z=>{
            setSelectedZone(prev=>prev?.id===z.id?null:z)
            setSelectedItem(prev=>prev?.data?.id===z.id?null:{type:"zone",data:z})
          }}
        />

        {/* 3 columns */}
        <div style={{display:"flex",gap:0,minWidth:540}}>

          {/* Col 1 — Alimentation */}
          <div style={{flex:1,borderRight:"1px solid #e2e8f0",paddingRight:12,minWidth:160}}>
            <ColHeader title="Alimentation" count={SINTER_INPUTS.length}/>
            {SINTER_INPUTS.map(item=><InputCard key={item.id} item={item}/>)}
            {/* HPipe linking col1 → col2 */}
            <div style={{display:"flex",alignItems:"center",justifyContent:"flex-end",
              marginTop:8,paddingRight:0}}>
              <HPipe color="#22c55e" active={true} flow={8.6} width={32} unit="m/min"/>
              <Arrow color="#22c55e" active={true} dir="right"/>
            </div>
            {/* Pressure card */}
            <div style={{
              background:"white",border:"1px solid #e2e8f0",borderRadius:8,
              padding:"10px 12px",marginTop:10,
              boxShadow:"0 1px 3px rgba(0,0,0,0.04)"
            }}>
              <div style={{fontSize:10,fontWeight:700,color:"#374151",marginBottom:8}}>
                Áp Suất Hệ Thống
              </div>
              {[
                {label:"Áp suất hút",   value:"-40.0", unit:"kPa", color:"#ef4444"},
                {label:"Nhiệt độ khói", value:"88.8",  unit:"°C",  color:"#f59e0b"},
              ].map(r=>(
                <div key={r.label} style={{
                  display:"flex",alignItems:"center",justifyContent:"space-between",
                  padding:"5px 0",borderBottom:"1px solid #f8fafc"
                }}>
                  <span style={{fontSize:10,color:"#64748b"}}>{r.label}</span>
                  <div style={{display:"flex",alignItems:"baseline",gap:3}}>
                    <span style={{fontSize:14,fontWeight:800,
                      color:r.color,fontFamily:"monospace"}}>{r.value}</span>
                    <span style={{fontSize:9,color:"#94a3b8"}}>{r.unit}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Col 2 — Machine Thiêu Kết + zone grid */}
          <div style={{flex:1.3,borderRight:"1px solid #e2e8f0",padding:"0 12px",minWidth:180}}>
            <ColHeader
              title="Thiêu Kết"
              count={1}
              extra={
                <div style={{display:"flex",gap:5}}>
                  <button onClick={()=>setMachineOn(true)} style={{
                    padding:"3px 9px",border:"none",borderRadius:5,cursor:"pointer",fontSize:10,
                    fontWeight:600,background:machineOn?"#22c55e":"#f1f5f9",
                    color:machineOn?"white":"#64748b"
                  }}>Start</button>
                  <button onClick={()=>setMachineOn(false)} style={{
                    padding:"3px 9px",border:"none",borderRadius:5,cursor:"pointer",fontSize:10,
                    fontWeight:600,background:!machineOn?"#ef4444":"#f1f5f9",
                    color:!machineOn?"white":"#64748b"
                  }}>Stop</button>
                </div>
              }
            />
            <MachineCard item={SINTER_MACHINE} running={machineOn} te={TE1206}/>
            <ZoneGrid/>
          </div>

          {/* Col 3 — Flux gaz (outputs) */}
          <div style={{flex:1,paddingLeft:12,minWidth:160}}>
            <div style={{display:"flex",alignItems:"center",marginBottom:12}}>
              <Arrow color="#ef4444" active={true} dir="left"/>
              <HPipe color="#ef4444" active={true} width={20}/>
              <div style={{flex:1}}>
                <ColHeader title="Flux gaz" count={SINTER_OUTPUTS.length}/>
              </div>
            </div>
            {SINTER_OUTPUTS.map(item=><OutputCard key={item.id} item={item}/>)}
          </div>

        </div>
      </div>

      {/* ── Right detail panel ── */}
      <div style={{
        width:268,background:"white",borderLeft:"1px solid #e2e8f0",
        flexShrink:0,overflowY:"auto"
      }}>
        <DetailPanel/>
      </div>
    </div>
  )
}


export { SiloGauge, SiloDetailPanel, SiloBalanceView, ZoneGauge, SinterBelt, SinteringLineView }
